import { Component, computed, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';

import { startWith, switchMap } from 'rxjs';

import { PreviewDevice, SurveyModel } from '@empathy/survey/base';

import { IEditorForm } from '../../models/survey-editor/editor-form.interface';

@Component({
  selector: 'empathy-welcome-page-preview',
  templateUrl: 'welcome-page-preview.component.html',
  styleUrls: ['./welcome-page-preview.component.scss']
})
export class WelcomePagePreviewComponent {
  editorForm = input.required<FormGroup<IEditorForm>>();

  readonly welcomeDetails$ = computed<{ stimulus: SurveyModel['welcomeStimulus']; html: string; title: string; useTitleInd: boolean }>(() => {
    const surveyModel = this.editorFormValue$() as SurveyModel;

    return {
      stimulus: surveyModel.welcomeStimulus ?? [],
      html: surveyModel.welcomeHtml ?? '',
      title: surveyModel.title ?? '',
      useTitleInd: surveyModel.settings?.useTitleInd ?? true
    };
  });

  previewDevice = PreviewDevice;

  private readonly editorFormValue$ = toSignal(
    toObservable(this.editorForm).pipe(switchMap((editorForm) => editorForm.valueChanges.pipe(startWith(editorForm.value)))),
    { initialValue: {} }
  );
}
